import React from 'react';
import ProductPageContain from '../../../Componant/Ecommerce/ProductPage';

const ProductPage = () => {
  return (
    <div className='page-body'>
      <ProductPageContain />
    </div>
  );
};

export default ProductPage;
